export const ATTENDANCE_COLORS = {
  pending: "#E3183C",
  marked: "#1D9B50",
  ink: "#121212",
  muted: "#6B6B70",
  label: "#8A8A8F",
  border: "#DDDDE1",
  inputPrefix: "#F1F1F3",
  placeholder: "#B0B0B5",
  white: "#FFFFFF",
  screenBg: "#F7F7F8",
  successBg: "#E6F5EC",
  onColorSoft: "rgba(255,255,255,0.82)",
  badgeBg: "rgba(255,255,255,0.22)",
  divider: "rgba(255,255,255,0.3)",
  scrim: "rgba(18,18,18,0.45)",
} as const;
